import Box from '@mui/material/Box'
import Snake from 'snake-game-react'

const SnakeGame = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* <Box
        sx={{
          height: 200,
          width: 200,
          outline: '1px red solid',
          position: 'relative',
        }}
      > */}
      <Snake color1="#248ec2" color2="#1d355e" backgroundColor="#ebebeb" />
      {/* </Box> */}
    </Box>
  )
}

export default SnakeGame
